import React from 'react'

const Manual_editar_colores_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Editar colores para el e-commerce
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Personaliza la paleta de colores de tu tienda online para reflejar tu identidad visual.
        </p>
        <iframe
          src="https://scribehow.com/embed/Editar_colores_para_el_e-commerce__Ab7B-yDQQMGPO6ykgoVgsQ?as=scrollable"
          className="scribe-iframe-general-118"
          width="100%"
          height="15100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_editar_colores_ecommerce
